<script setup lang="ts"></script>
<template>
	<svg class="svg" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M18.9106 10.6348C18.9106 10.2896 18.614 10.0098 18.2482 10.0098H7.13685C6.771 10.0098 6.47442 10.2896 6.47442 10.6348C6.47442 10.9799 6.771 11.2598 7.13685 11.2598H18.2482C18.614 11.2598 18.9106 10.9799 18.9106 10.6348Z"
			fill="#6F6B7D" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M15.5982 7.10689C15.3395 7.35096 15.3395 7.74669 15.5982 7.99077L18.4008 10.6349L15.5982 13.2791C15.3395 13.5232 15.3395 13.9189 15.5982 14.163C15.8569 14.4071 16.2764 14.4071 16.5351 14.163L19.806 11.0769C19.9302 10.9597 20 10.8007 20 10.6349C20 10.4692 19.9302 10.3102 19.806 10.193L16.5351 7.10689C16.2764 6.86281 15.8569 6.86281 15.5982 7.10689Z"
			fill="#6F6B7D" />
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M2.5 6C2.5 4.75736 3.56769 3.75 4.88474 3.75H10.5728C11.7768 3.75 12.792 4.59676 12.9396 5.72416L13.0938 6.90254C13.1387 7.24512 12.8807 7.55713 12.5176 7.59945C12.1545 7.64177 11.8238 7.39836 11.779 7.05579L11.6247 5.8774C11.5591 5.37634 11.1079 5 10.5728 5H4.88474C4.29938 5 3.82486 5.44772 3.82486 6V15.25C3.82486 15.8023 4.29938 16.25 4.88474 16.25H10.5728C11.1079 16.25 11.5591 15.8737 11.6247 15.3726L11.779 14.1942C11.8238 13.8516 12.1545 13.6082 12.5176 13.6505C12.8807 13.6929 13.1387 14.0049 13.0938 14.3475L12.9396 15.5258C12.792 16.6532 11.7768 17.5 10.5728 17.5H4.88474C3.56768 17.5 2.5 16.4926 2.5 15.25V6Z"
			fill="#6F6B7D" />
	</svg>
</template>
